import { post } from "../utils/backend";
import { getMockData, mock } from "./mock/Mock";



const getConfigs = async (): Promise<Map<string, any>>=> {
    if(mock){
        return getMockData("getConfigs");
    }
    const resultOrErrorCode = await post<{}, Map<string, any>>("/mix/getConfigData", {}); 
    if(typeof resultOrErrorCode === 'string'){
        // 错误码处理
        return new Map();
    } 
    return resultOrErrorCode;
};

export const MixApi = {
    getConfigs
}